import React from 'react';

import { SaveButton } from '../../../common/button/save-button/SaveButton';

import './UsersView.css';

export const UserViewRoleAndPermissionsTab = ({ context, user, navigateBack, handleNavigationClick }) => {
  const handleBackClick = () => {
    navigateBack();
  };

  const handleNextClick = () => {
    handleNavigationClick('userSites');
  };

  return (
    <div className="tab-container">
      <div className="role-list-container">
        <label className={'admin-label-roles'}>Roles:</label>
        <div className="roles-list">
          {user.userRoles.map((role, index) => (
            <div key={index} className={'input-label-admin-roles'}>
              {role}
            </div>
          ))}
        </div>
      </div>

      <div className="user-view-buttons">
        <SaveButton
          color={'#ffffff'}
          textColor={'#db602e'}
          border={'1px solid #db602e'}
          title={'Back'}
          onClick={handleBackClick}
        />
        <SaveButton color={'#db602e'} title={'Next'} onClick={handleNextClick} />
      </div>
    </div>
  );
};
